import React from 'react'
import LinguistNotesView from '../../../UI/configuration-management/components/LinguistNotesView'

type Props = {
  show: boolean
  interpreterId: string
  interpreterName: string
  onClose: () => void
}

export const AddNoteModal: React.FC<Props> = ({show, interpreterId, interpreterName, onClose}) => {
  if (!show) return null

  return (
    <div className='ipivis-note-overlay' onClick={onClose}>
      <div className='ipivis-note-panel' onClick={(e) => e.stopPropagation()}>
        <div className='ipivis-note-panel__header'>
          <h3 className='ipivis-note-panel__title'>Internal Notes — {interpreterName}</h3>
          <button className='ipivis-note-panel__close' onClick={onClose} type='button'>
            ×
          </button>
        </div>
        <div className='ipivis-note-panel__body'>
          <LinguistNotesView linguistId={interpreterId} />
        </div>
      </div>
    </div>
  )
}
